module.exports = __webpack_public_path__ + "static/media/gsb-iconSport&Activities.c10e3ad5.svg";